import { Money } from '@rygen/rygen-ui/model';

import { FreightAllowanceAutoCalc } from './FreightAllowanceAutoCalc';

export class FreightAllowance {
  enabled: boolean = false;
  amount?: Money;
  autoCalc?: FreightAllowanceAutoCalc;

  constructor(opts?: Partial<FreightAllowance>) {
    this.enabled = opts?.enabled ?? false;
    this.amount = opts?.amount ? new Money(opts.amount) : undefined;
    this.autoCalc = opts?.autoCalc
      ? new FreightAllowanceAutoCalc(opts?.autoCalc)
      : undefined;
  }
}
